/** FGTS × QI Tech. */

import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult(params) {
  return http.get('/qitech/fgts/balance', { params });
}

export async function simulate(data) {
  return http.post('/qitech/fgts/simulation', data);
}

export async function save(data) {
  return http.post('/qitech/fgts/proposal', data);
}

export async function verify(params) {
  return http.get('/qitech/fgts/proposal', { params });
}

export async function cancel(id, data) {
  return http.delete(`/qitech/fgts/proposal/${id}`, { data });
}

export async function withdrawalProposal(data) {
  return http.post('/qitech/fgts/proposal/reversal', { ...data });
}

export async function unravel(id, data) {
  return http.delete(`/qitech/fgts/reserve_balance/${id}`, { data });
}

export async function receipt(id, params) {
  return http.get(`/qitech/fgts/reserve_balance/${id}/generate_receipt`, { params });
}

export async function list(params) {
  return http.get('/qitech/fgts/balance-wait-list', { params });
}

export async function removeItemsFromWaitList(params) {
  return http.delete('/qitech/fgts/balance-wait-list', { params });
}

export async function clearCache(params) {
  return http.post('/qitech/fgts/clear-balance-cache', { ...params });
}

export async function getCreditCardStatus(document, creditorBank) {
  const payload = {
    document,
    creditor_bank: creditorBank,
  };

  return http.get(`${ALT_API_URL}/qitech/fgts/credit-operation-status`, { params: payload });
}

export async function forceSignature(data) {
  return http.post('/qitech/fgts/sign-debit', data);
}

export async function approve(data) {
  return http.post(`${ALT_API_URL}/qitech/fgts/credit-operation`, data);
}

export async function tryAgain(data) {
  return http.put(`${ALT_API_URL}/qitech/fgts/credit-operation`, data);
}

/* Quitação */
export async function fetchRenegotiation(data) {
  return http.post('/qitech/fgts/renegotiation/simulation', data);
}

export async function fetchRenegotiationList(params) {
  return http.get('/qitech/fgts/renegotiation/proposal/list', { params });
}

export async function renegotiationProposal(data) {
  return http.post('/qitech/fgts/renegotiation/proposal', data);
}

export async function deleteRenegotiationProposal(params) {
  return http.delete('/qitech/fgts/renegotiation/proposal', { params });
}

/* CCB — mesma esteira, prefixo próprio na API */
export async function validateSimulation(data) {
  return http.post('/ccb/fgts/check-simulation', data);
}

export async function reSimulateFGTS(data) {
  return http.post('/ccb/fgts/resimulate', data);
}

/* Quitação (PayoffCharges) — módulo à parte da renegociação acima */
export async function listBankSlips(params) {
  return http.get('/qitech/fgts/payoff/bank-slips', { params });
}
